import React, { useCallback, useEffect } from 'react';
// Utils
import { delay, useSetState } from 'utils';
import { setBadgeType } from 'utils/events';
// Sales Context
import { useSalesOrderState } from 'context/SalesOrderContext';
import * as salesFlags from 'context/SalesOrderContext/statusFlags';
// Types
import { OrderLinesProps, SalesOrderProps } from 'types/salesOrder';
// Elements
import Badge from 'elements/Badge';
import Button from 'elements/Button';
import ListCell from 'elements/ListCell';
import { TextField } from 'elements/Forms';
import { Modal, ModalContent, ModalFooter, ModalHeader } from 'elements/Modal';
// Styles
import styles from './style/salesDetails.module.css';

interface ChildLineProps {
  event: SalesOrderProps
  childEvent: OrderLinesProps,
}

function SubSalesOrder({
  event,
  childEvent,
}:ChildLineProps) {
  // Sales State
  const { salesState } = useSalesOrderState()
  const initialState = {
    event: {},
    loading: true,
    modalActive: false,
    confirmModalActive: false,
    comment: '',
    resendEvents: {},
  }
  const [state, setState] = useSetState(initialState);
  // Handlers
  /*  async function patchData() {
    await patchEvents({
      appDispatch,
      salesOrderDispatch,
      event: {
        targetSalesOrder: childEvent.dispatcherSalesOrderId,
        targetItemNumber: childEvent.itemId.toString(),
        asn: '0',
        targetLineStatus: childEvent.processingStatus,
        targetShippedQuantity: childEvent.orderedQuantity ? childEvent.orderedQuantity.toString() : '',
        processingStatus: 'CLOSED',  
        salesOrderId: childEvent.salesOrderId,
        salesOrderLineId: childEvent.salesOrderLineId,  
      },
      eventFilters,
    })
    await resendEvents({
      appDispatch,
      salesOrderDispatch,
      eventFilters,
      event: mutateCloseEvent(event, childEvent),
      orgRef,
    })
  } */

  const initiatePage = useCallback(async () => {
    await delay(200);
    if (salesState === salesFlags.GET_SALES_ORDER_SUCCESS || salesState === salesFlags.RESEND_SALES_ORDER_SUCCESS) {
      setState({ loading: false });
    }
  }, [setState, salesState]);

  useEffect(() => {
    initiatePage();
  }, [initiatePage]);

  return (
    <div className={styles.container}>
      <>
        <div className={styles.grid}>
          <div className={styles.processingStatus}>
            <div className="subtitle1">
              <Badge
                badgeStyle={setBadgeType((childEvent.processingStatus === 'ERROR' || childEvent.processingStatus === 'LINES_IN_ERROR') ? 'FAILED' : childEvent.processingStatus)}
                label={(childEvent.processingStatus === 'ERROR' || childEvent.processingStatus === 'LINES_IN_ERROR') ? 'FAILED' : childEvent.processingStatus}
              />        
            </div>
          </div>
          <div className={styles.maindetail}>
            <span className="small-print">ERP Order number</span>
            <strong>
              {childEvent.targetSalesOrder || '-'}
            </strong>
          </div>
          <div className={styles.details}>
            <ListCell label="ERP Warehouse ID" responsive="1280" value={childEvent.packSite || '-'} />
            <ListCell label="Ordered Qty" responsive="1280" value={childEvent.orderedQuantity ? `${childEvent.orderedQuantity} ${childEvent.unitOfMeasure}` : '-'} />
            <ListCell label="ERP Code" responsive="1280" value={childEvent.targetItemNumber || '-'} />
            <ListCell label="PIN Code" responsive="1280" value={childEvent.packId || '-'} />
          </div>
        </div>
        <Modal
          active={state.modalActive}
        >
          <ModalHeader heading="Event Close" />
          <ModalContent>
            <TextField
              handler={(e:React.ChangeEvent<HTMLInputElement>)  => setState({ comment: e.target.value })}
              label="Comment"
              value={state.comment}
            />
          </ModalContent>
          <ModalFooter>
            <Button handler={() => setState({ modalActive: false })}>
              Cancel
            </Button>
            <Button
              btnStyle="secondary"
              disabled={!state.comment}
              handler={() => setState({ confirmModalActive: true })}
            >
              Confirm
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          active={state.confirmModalActive}
        >
          <ModalHeader heading="Event Close" />
          <ModalContent>
            <p>Are you sure you want to close?</p>
          </ModalContent>
          <ModalFooter>
            <Button handler={() => setState({ modalActive: false, confirmModalActive: false })}>
              Cancel
            </Button>
            <Button
              btnStyle="secondary"
            >
              Confirm
            </Button>
          </ModalFooter>
        </Modal>
      </>
    </div>
  );
}

export default SubSalesOrder;
